import { metaAccount } from '@/router/meta-config'
const permissionKey = 'PAGE'

export default [
  {
    path: '/personal-details',
    name: 'page-personal-details',
    component: () => import('@/pages/personal-details'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/personal-detail/:id',
    name: 'page-personal-detail',
    component: () => import('@/pages/personal-detail'),
    props: (route) => ({ id: Number(route.params.id) }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
